<template>
  <div>
    <v-col cols="3">
      <v-btn
        block
        height="42px"
        color="#1db954"
        class="download-btn"
        @click="openModal('create')"
        style="color: black"
      >
        <v-icon>mdi mdi-plus-thick</v-icon>
        Neu
      </v-btn>
    </v-col>
    <v-data-table
      :key="healthUpdateKey"
      :headers="headers"
      :search="performSearch"
      :items="healths"
      :loading="isLoading"
      :footer-props="{
        'items-per-page-text': 'Zeilen pro Seite',
      }"
    >
      <template v-slot:item.actions="{ item }">
        <div class="button-container">
          <v-icon
            small
            class="edit green--text icon-style"
            @click="openModal('update', item)"
          >
            mdi-pencil
          </v-icon>
          <v-icon
            small
            class="delete green--text icon-style"
            @click="openDeleteModal('delete', item)"
          >
            mdi-delete
          </v-icon>
        </div>
      </template>
    </v-data-table>
    <create-health
      :health="{ name: '', description: '' }"
      :visible="dialogType === 'create'"
      :id="null"
      @close="closeModal"
      @addItem="addItem"
      v-on:updated-table="updatedList"
    />
    <update-health
      :key="healthUpdateKey"
      :health="selectedHealth"
      :visible="dialogType === 'update'"
      :id="selectedHealth.id"
      @close="closeModal"
      @updateItem="updateItem"
      v-on:updated-table="updatedList"
    />
    <delete-health
      :visible="dialogType === 'delete'"
      :health="selectedHealth"
      :item-list="itemList"
      v-on:updated-table="updatedList"
      @close="closeDeleteModal"
    ></delete-health>
  </div>
</template>

<script>
import CreateHealth from "./CreateHealth";
import UpdateHealth from "./UpdateHealth";
import DeleteHealth from "./DeleteHealth";
import { mapActions, mapGetters } from "vuex";

export default {
  components: {
    CreateHealth,
    UpdateHealth,
    DeleteHealth,
  },
  data() {
    return {
      headers: [
        { text: "Abkürzung", value: "name" },
        { text: "Beschreibung", value: "description" },

        { text: "", value: "actions", sortable: false },
      ],
      itemList: [],
      healthUpdateKey: null,
      healthList: [],
      isLoading: false,
      dialogType: "",
      selectedHealth: {},
      localSearch: null,
      showDeleteModal: false,
    };
  },
  computed: {
    ...mapGetters(["getSearchquery", "healths"]),

    performSearch() {
      return this.getSearchquery;
    },
  },
  mounted() {
    this.localSearch = this.getSearchquery;
  },
  created() {
    this.fetchData();
  },
  methods: {
    ...mapActions(["fetchHealths", "createHealth", "updateHealth"]),
    editHealth(health) {
      this.selectedHealth = { ...health };
      this.dialogType = "update";
    },
    updatedList(boolean) {
      if (boolean) {
        this.fetchData();
      }
    },

    openModal(type, health) {
      this.dialogType = type;
      if (type === "update") {
        this.selectedHealth = { ...health };
      }
    },
    openDeleteModal(type, health) {
      this.dialogType = type;
      if (type === "delete") {
        this.selectedHealth = { ...health };
      }
    },
    closeModal() {
      this.dialogType = "";
      this.selectedHealth = {};
    },
    closeDeleteModal() {
      this.showDeleteModal = false;
      this.dialogType = "";
      this.selectedHealth = {};
    },
    async addItem(newItem) {
      this.isLoading = true;
      await this.createHealth(newItem);
      this.closeModal();
    },
    async updateItem(item) {
      this.isLoading = true;
      await this.updateHealth(item);
      this.UpdateKey += 1;
      this.closeModal();
    },
    fetchData() {
      this.isLoading = true;
      this.fetchHealths()
        .then(() => {
          //    this.$store.commit("setCoverageTypeResults", response.data);
          this.coverages = response.data;
          this.isLoading = false;
        })
        .catch((error) => {
          console.log(error);
          this.isLoading = false;
        });
    },
    handleSearch(query) {
      this.getSearchquery = query;
    },
  },
};
</script>
<style lang="scss" scoped>
.icon-style {
  border: 1px solid #494949;
  padding: 3px;
  border-radius: 5px;
  width: 42px;
  height: 42px;
  margin-left: -60px !important;
}

.button-container {
  display: flex;
  align-items: center;
}
.button-container .delete {
  position: absolute;
  right: 15px;
}
.button-container .edit {
  position: absolute;
  right: 67px;
}
.add-button {
  outline: none !important;
  margin-bottom: 10px;
  width: 220px;
}
</style>
